var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgCloseTag = function SvgCloseTag(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10.281,
    height: 10.281
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    fill: "currentColor",
    d: "m8.761,0.707l0.813,0.813l-3.62,3.62l3.62,3.62l-0.813,0.813l-3.62,-3.62l-3.62,3.62l-0.813,-0.813l3.62,-3.62l-3.621,-3.62l0.813,-0.813l3.62,3.62l3.62,-3.62l0.001,0z"
  })));
};
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTAuMjgxIiBoZWlnaHQ9IjEwLjI4MSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4NCiAgPHBhdGggc3Ryb2tlPSJjdXJyZW50Q29sb3IiIGZpbGw9ImN1cnJlbnRDb2xvciIgZD0ibTguNzYxLDAuNzA3bDAuODEzLDAuODEzbC0zLjYyLDMuNjJsMy42MiwzLjYybC0wLjgxMywwLjgxM2wtMy42MiwtMy42MmwtMy42MiwzLjYybC0wLjgxMywtMC44MTNsMy42MiwtMy42MmwtMy42MjEsLTMuNjJsMC44MTMsLTAuODEzbDMuNjIsMy42MmwzLjYyLC0zLjYybDAuMDAxLDB6IiAvPg0KPC9zdmc+DQo=";
export { SvgCloseTag as ReactComponent };